module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-link', {
    staticClass: "u-user-info",
    attrs: {
      "link": "dashboard",
      "no-underline": true
    }
  }, [_c('span', {
    staticClass: "u-user-info__wrapper"
  }, [_c('span', {
    staticClass: "u-user-info__name p"
  }, [_vm._v(_vm._s(_vm.user.full_name || ""))]), _vm._v(" "), _c('span', {
    staticClass: "u-user-info__role h6"
  }, [_vm._v(_vm._s(_vm.userRole.string || ""))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04497cd0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/UserInfo.vue
// module id = 126
// module chunks = 3